// extracted by mini-css-extract-plugin
module.exports = {"content":"e_ts","opened":"e_us","buttonIcon":"e_vs","buttonIconOpen":"e_ws","toggle":"e_xs","collapsible":"e_ys"};